exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#gridComponent[data-v-08752d88] {\n  height: auto !important;\n  margin-bottom: 50px;\n}\n.ag-grid-comp[data-v-08752d88] .estilo-grilla {\n  height: auto !important;\n}\n", ""]);

// exports
